import { Component } from "react";

import { cn } from "@btnet/utilities-core";

import { BTSelect, type BTSelectProps } from "commonComponents/btWrappers/BTSelect/BTSelect";

import "./LeadActivityIconPicker.less";

import { leadActivityIconClassMap } from "../IconSelectItem";

/**
 * Renders a dropdown with icon swatches
 * @example
 * <IconPicker<IFormValues> id="myIcon" value={value.myIcon} onChange={setFieldValue} />
 */
export class LeadActivityIconPicker<FormValues> extends Component<
    BTSelectProps<FormValues, undefined>
> {
    render() {
        const { className, ...selectProps } = this.props;

        const selectClassName = cn("IconPicker", className, {
            // a value is selected, pad cursor
            IconPickerCursorPadding: this.props.value !== undefined,
        });

        return (
            <BTSelect<FormValues>
                {...selectProps}
                className={selectClassName}
                dropdownClassName="IconPicker"
                customItemRender={(selectItem) => (
                    <>
                        <span
                            className={cn(
                                "icon-picker-swatch",
                                leadActivityIconClassMap[selectItem.value],
                            )}
                        />
                        {selectItem.title}
                    </>
                )}
            />
        );
    }
}
